import { render, staticRenderFns } from "./SalepointsDialog.vue?vue&type=template&id=24f59e30&scoped=true&"
import script from "./SalepointsDialog.vue?vue&type=script&lang=js&"
export * from "./SalepointsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f59e30",
  null
  
)

export default component.exports